import React from 'react';
import { useEntitlements } from '../contexts/EntitlementContext';

/**
 * In-app re-engagement banner (Channel 2 of shared-docs/re-engagement-nudges.md).
 *
 * Rendered from the launch-time entitlements response when the server returns a
 * fresh `inAppNudge` (< 30 days old) that hasn't been dismissed on this device.
 * Styled in Brain Grid's toast/design language: accent left border, soft shadow,
 * dismissible. One banner max; never blocks the UI.
 */
export default function NudgeBanner() {
  const { inAppNudge, dismissNudge } = useEntitlements();
  if (!inAppNudge) return null;

  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-3 rounded-2xl border border-l-4 border-primary-500 border-l-primary-500
                 bg-white dark:bg-night-surface shadow-[0_8px_30px_rgba(0,0,0,0.18)]
                 px-4 py-3 animate-pop-in"
    >
      <span aria-hidden="true" className="text-xl leading-none mt-0.5">🧠</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 dark:text-night-text">
          {inAppNudge.title}
        </p>
        <p className="text-xs text-gray-500 dark:text-night-muted mt-0.5 leading-snug">
          {inAppNudge.body}
        </p>
      </div>
      <button
        type="button"
        onClick={dismissNudge}
        aria-label="Dismiss"
        className="p-1 -m-1 rounded-lg text-gray-400 hover:text-gray-600
                   dark:text-night-muted dark:hover:text-night-text transition-colors"
      >
        <span aria-hidden="true" className="text-lg leading-none">×</span>
      </button>
    </div>
  );
}
